import { createApp } from 'vue'
import store from 'store'

import AddedToCartNotification from './AddedToCartNotification.vue'

const el = '.nti-component--cart-notification'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){

        const dataShoppingUrl = DOM.dataset.datashoppingurl
        const continueShoppingLabel = DOM.dataset.continueshoppinglabel
        const toBasketLabel = DOM.dataset.tobasketlabel
        const toBasketUrl = DOM.dataset.tobasketurl
        
        const app = createApp(AddedToCartNotification, {
            dataShoppingUrl: dataShoppingUrl,
            continueShoppingLabel: continueShoppingLabel,
            toBasketLabel: toBasketLabel,
            toBasketUrl: toBasketUrl
        })
        app.use(store)
        app.mount(el)
    }
}

export default {
    render
}